enum IngredientTemplate {MY, ALL};
export {IngredientTemplate};
